export default {
  title: '3D Modellar',
  heading: '404 Xatolik',
  error1: 'Sahifa topilmadi',
  error2: 'Iltimos, manzilni tekshiring yoki ',
  error3: ' bosh sahifaga qayting',
  description: "Mahsulotning 3D model sifatida ko'rish imkoniyatiga egasiz!",
}